import { render, staticRenderFns } from "./SurveyList.vue?vue&type=template&id=13cf79f3&"
import script from "./SurveyList.vue?vue&type=script&lang=js&"
export * from "./SurveyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports